// Model IDs are noisy ("claude-opus-4-6"); show a tidy label ("Opus 4.6").
// Best-effort for Claude/GPT, otherwise return the raw id so unknown models
// aren't mangled.
export function formatModelName(model: string): string {
  const raw = model.trim();
  if (!raw) return raw;
  if (/claude|anthropic/i.test(raw)) {
    const family = raw.match(/fable|opus|sonnet|haiku/i)?.[0];
    if (!family) return raw;
    const label =
      family.charAt(0).toUpperCase() + family.slice(1).toLowerCase();
    const version = raw.match(/\d+(?:-\d+)?/)?.[0]?.replace("-", ".");
    return version ? `${label} ${version}` : label;
  }
  if (/^gpt/i.test(raw)) {
    const rest = raw.replace(/^gpt[-\s]?/i, "");
    if (!rest) return raw;
    const tier = ["astra", "sol", "terra", "luna"].find((candidate) =>
      rest.toLowerCase().endsWith(`-${candidate}`)
    );
    if (!tier) return `GPT-${rest}`;
    const version = rest.slice(0, -tier.length - 1);
    return `GPT-${version} ${tier.charAt(0).toUpperCase()}${tier.slice(1).toLowerCase()}`;
  }
  return raw;
}
